import { Box, ButtonBase, Collapse, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { GREEN_ACCENT, TEXT_SUB, g } from "../styles";

const s = {
  heading: { margin: 0 },
  summary: {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    textAlign: "start",
    justifyContent: "space-between",
    borderRadius: "8px",
    "&.Mui-focusVisible": { outline: `2px solid ${GREEN_ACCENT}`, outlineOffset: "4px" },
  },
  summaryText: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "2px" },
  chevron: { color: TEXT_SUB, fontSize: 22, marginTop: "2px", flexShrink: 0 },
  body: { paddingTop: "12px" },
};

/**
 * One column of the page. On desktop: a card with the shared header (title,
 * optional badge, subtitle) above its content — identical in every column so
 * they line up. When `collapsible` (mobile): the header becomes the toggle of
 * an accordion, with the same chevron behaviour as CustomAccordion.
 */
const SectionCard = ({ title, subtitle, badge, collapsible, expanded, onToggle, onEntered, isRTL, bodyId, children }) => {
  if (!collapsible) {
    return (
      <Box sx={g.card}>
        <Box sx={g.cardHeader}>
          <Box sx={g.cardTitleRow}>
            <Typography component="h2" sx={g.cardTitle}>{title}</Typography>
            {badge}
          </Box>
          <Typography sx={g.cardSub}>{subtitle}</Typography>
        </Box>
        {children}
      </Box>
    );
  }

  const Chevron = isRTL ? KeyboardArrowLeftOutlinedIcon : KeyboardArrowRightIcon;

  return (
    <Box sx={g.card}>
      <Box component="h2" sx={s.heading}>
        <ButtonBase onClick={onToggle} aria-expanded={expanded} aria-controls={bodyId} sx={s.summary}>
          <Box component="span" sx={s.summaryText}>
            <Box component="span" sx={g.cardTitleRow}>
              <Typography component="span" sx={g.cardTitle}>{title}</Typography>
              {badge}
            </Box>
            <Typography component="span" sx={g.cardSub}>{subtitle}</Typography>
          </Box>
          <Chevron
            aria-hidden="true"
            sx={{ ...s.chevron, transform: expanded ? `rotate(${isRTL ? -90 : 90}deg)` : "none" }}
          />
        </ButtonBase>
      </Box>
      <Collapse in={expanded} id={bodyId} onEntered={onEntered}>
        <Box sx={s.body}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default SectionCard;
